import { FeatureDataSource } from "../../../ducks/showFeature/types";

export const getDataSource = (dataSourceName: string, dataSources: FeatureDataSource[]): FeatureDataSource =>
  dataSources?.find(({ name }) => name === dataSourceName);
